import React from 'react';
import propTypes from 'prop-types';
import MusicGrid from '../../components/MusicGrid';
import * as api from '../../requests/loader';
import MusicDetailAdapter from '../../components/MyMusicContent/MusicDetailAdapter';
import Placeholder from '../../containers/Placeholder';
export const SIMILAR_ARTISTS = 'similar-artists';
export const ARTIST_ALBUMS = 'artist-albums';

export class SimpleArtistGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            showPlaceholder: false
        };
    }

    getItems() {
        const { type, artistId, setIsFetching } = this.props;
        let requester = null;
        if (type === ARTIST_ALBUMS) {
            requester = api.getArtistAlbums;
        }
        if (type === SIMILAR_ARTISTS) {
            requester = api.getArtistSimilar;
        }
        if (requester) {
            setIsFetching(true);
            requester({ artistId })
                .then(res => {
                    const items = MusicDetailAdapter({ response: res });
                    if (items.length > 0)
                        this.setState({ items }, () => {
                            setIsFetching(false);
                        });
                    else
                        this.setState({ showPlaceholder: true }, () => {
                            setIsFetching(false);
                        });
                })
                .catch(error => {
                    console.error('SimpleArtistGrid error', error);
                    this.setState({ showPlaceholder: true }, () => {
                        setIsFetching(false);
                    });
                });
        }
    }

    componentDidMount() {
        this.getItems();
    }

    render() {
        const { items, showPlaceholder } = this.state;
        const { onFocus, type: typeProp } = this.props;
        const type = typeProp === SIMILAR_ARTISTS ? 'circle' : 'square';
        const gridType = typeProp === SIMILAR_ARTISTS ? 'artist' : 'album';
        const musicGridProps = {
            items,
            onFocusHandler: onFocus,
            gridType,
            type
        };
        if (showPlaceholder) {
            return <Placeholder type={typeProp === SIMILAR_ARTISTS ? 'similarArtist' : ''} />;
        }
        return <MusicGrid {...musicGridProps} />;
    }
}

SimpleArtistGrid.propTypes = {
    type: propTypes.oneOf(SIMILAR_ARTISTS, ARTIST_ALBUMS).isRequired,
    setIsFetching: propTypes.func.isRequired,
    artistId: propTypes.string.isRequired,
    onFocus: propTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/containers/ArtistDetail/SimpleArtistGrid.jsx